<template>
  <el-dialog custom-class="pharmacy-dialog" title="处方详情" :visible.sync="dialogVisible">
    <div class="pharmacy-detail">
      <div class="pharmacy-detail__header">
        <el-row class="mb10" type="flex" justify="space-between">
          <span class="title">{{ detailInfo.hosName }}处方</span>
        </el-row>
        <div>处方编号：{{ detailInfo.orderNo }}</div>
        <div>开方时间：{{ detailInfo.createTime | formatTime }}</div>
      </div>
      <ul class="pharmacy-detail__pat-info">
        <li>
          <span>患者姓名：{{ detailInfo.compatName }}</span>
          <span class="ml20">性别：{{ detailInfo.compatGender | formatterCompatGender }}</span>
          <span class="ml20">年龄：{{ detailInfo.compatAge }}岁</span>
        </li>
        <li>
          <span>初步诊断：{{ detailInfo.diagnosis }}</span>
        </li>
      </ul>
      <section class="pharmacy-detail__content drug-list">
        <div class="flex pt10 jcb">
          <div class="flex detail_title">
            <img v-if="detailInfo.orderType==='WESTERN_RECIPE'"
                 src="../../assets/icon/prescription/medicine.png" alt="">
            <img v-else src="../../assets/icon/prescription/zhongyao.png" alt="">
            <span class="fs16 bold ml10">{{ detailInfo.orderType|filter_drug_type }}药品</span></div>
          <span>总价：{{ detailInfo.totalPrice / 100 }}元 <span
              v-if="detailInfo.orderType==='CHINESE_RECIPE'">（代煎费: {{ detailInfo.decoctingPrice / 100 }}元）</span></span>
        </div>
        <ul class="drug-list__content" v-if="detailInfo.orderType==='WESTERN_RECIPE'">
          <li class="drug-list__content-item" v-for="item in detailInfo.drugList" :key="item.id">
            <div class="flex1">
              <el-row type="flex" justify="space-between">
                <div>
                  <span>{{ item.drugName }}</span>
                  <span class="ml20">{{ item.drugSpecification }}</span>
                </div>
                <div class="price">¥{{ item.drugUnitPrice / 100 }}</div>
              </el-row>
              <el-row type="flex" justify="space-between">
                <span>用法用量：{{ item.admission }}，{{ item.frequencyName }}，每次{{ item.dosage }}{{
                    item.dosageUnit
                  }}, 用药{{ item.useDays }}天</span>
                <span class="count">x{{ item.amount }}</span>
              </el-row>
              <el-row type="flex" justify="space-between">
                <div v-if="detailInfo.orderType==='WESTERN_RECIPE'">
                  <p>补充说明：{{ item.remarks }}</p>
                </div>
              </el-row>
            </div>
          </li>
        </ul>
        <ul class="drug-list__content" v-else>
          <li class="drug-list__content-item" v-for="item in detailInfo.drugList" :key="item.id">
            <div class="flex1">
              <el-row type="flex" justify="space-between">
                <div>
                  <span>{{ item.ypmc || item.drugName }}</span>
                  <span class="pl15 color_main3">{{ item.ypsl || item.dosage }}{{ item.jldw || item.dosageUnit }}</span>
                  <span class="pl15">{{ item.admission|filter_jianfu }}</span>
                </div>
                <div class="price">¥{{ item.drugUnitPrice / 100 }}</div>
              </el-row>
              <el-row class="btd mt15">
                <p>共{{ detailInfo.drugList.length }}味药，{{ detailInfo.tcmDosage }}付</p>
                <p>用法用量：{{ detailInfo.tcmAdmission }}</p>
              </el-row>
            </div>
          </li>
        </ul>
      </section>
      <div class="mt20 flex jca">
        <div class="flex1 flex column jcc">
          <span class="fs14 color_333">开方医生:</span>
          <!--<img :src="'data:image/png;base64,'+detailInfo.openStamp" alt="" class="width50">-->
          <img v-if="detailInfo.openStamp" :src="detailInfo.openStamp" alt="" class="width50">
          <span v-else>{{ detailInfo.docName }}</span>
        </div>
        <div class="flex1 flex column">
          <span class="fs14 color_333">审核医生:</span>
          <img v-if="detailInfo.auditStamp" :src="'data:image/png;base64,'+detailInfo.auditStamp" alt=""
               class="width50">
          <span v-else>{{ detailInfo.auditorName }}</span>
        </div>
      </div>
    </div>
    <div class="harvest-address flex1">
      <div class="harvest-address__header">
        <el-row class="mb10" type="flex" justify="end">
          <span class="status">{{ formatStatus(detailInfo.takeMode, detailInfo.status) }}</span>
        </el-row>
        <div v-if="detailInfo.takeHosInfo">出药单位：{{ detailInfo.takeHosInfo.hosName }}</div>
        <div>取药方式：{{ detailInfo.takeMode | formatTakeMode }}</div>
      </div>
      <div class="pt50 flex">
        <template v-if="detailInfo.status === 'WAITTAKE'">
          <el-button type="primary" @click="save">填写快递单号</el-button>
        </template>
        <el-button type="primary" plain v-if="waitInvite" @click="sureTakeOff">确认患者已取药</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script lang="es6">
import {timeFormat, sex} from "ty-vue-filters";
import {sexFilter} from "../../lib/filters"
import {formatStatus} from "../../filters/pharmacy";
import {tokenCache} from "../../lib/cache/Token"
import {filter_drug_type} from "../../filters/prescription";


export default {
  props: {
    visible: Boolean,
    detailInfo: Object
  },
  data() {
    return {
      reason: ""
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    waitInvite() {
      return this.detailInfo.status === 'WAITTAKE' && (this.detailInfo.takeMode === 'SELF' || this.detailInfo.takeMode === 'HOS_SELF')
    }
  },
  filters: {
    filter_drug_type,
    formatTime(time) {
      return timeFormat(time, "%Y/%m/%d %H:%M");
    },
    formatterCompatGender(code) {
      return sexFilter(code, 1);
    },
    formatTakeMode(code) {
      const takeModes = {
        SELF: "患者自取",
        LOGISTICS: "送药到家"
      };
      return takeModes[code];
    },
    filter_jianfu(str) {
      if (!str) return ''
      if (str === '煎服') {
        return ''
      } else {
        return str
      }
    }

  },
  methods: {
    formatStatus,
    async handleAudit(opts) {
      const options = {
        orderId: this.detailInfo.id,
        token: tokenCache.get(),
        ...opts
      }
      const {code, msg} = await this.$http('smarthos.recipe.order.audit', options)
      if (code === "0") {
        this.$emit("update:visible", false);
      } else {
        this.$message.error(msg);
      }
    },


    save() {
      this.$prompt('请输入快递单号', '提示')
          .then(async ({value}) => {
            const {code} = await this.$http('smarthos.recipe.order.logistics.save', {
              logisticsNo: value,
              orderId: this.detailInfo.id
            })
            if (code === '0') {
              this.$notify({
                title: '提示',
                message: '保存成功'
              })
            } else {
              //this.$message.error(msg);
            }
          })
    },


    async sureTakeOff() {
      const {code} = await this.$http('smarthos.recipe.order.dispensing', {
        orderId: this.detailInfo.id,
        token: tokenCache.get()
      })
      if (code === '0') {
        this.$message.success('确认取药成功');
        this.dialogVisible = false
      }
    }

  }
};
</script>

<style lang="scss">
.pharmacy-dialog {
  .el-dialog {
    &__header {
      border-bottom: 1px solid #e8e8e8;
    }

    &__body {
      padding-top: 12px;
      display: flex;
    }
  }

  .pharmacy-detail {
    width: 400px;
    border-right: 1px solid #e8e8e8;
    padding-right: 45px;

    &__header {
      border-bottom: 1px dashed #e5e5e5;
      padding-bottom: 10px;

      .title {
        font-size: 18px;
        color: #333333;
      }

      .status {
        color: #3692f9;
      }
    }

    &__pat-info {
      padding: 12px 0;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      border-bottom: 1px dashed #e5e5e5;
    }

    &__footer {
      display: flex;
      justify-content: space-around;
      height: 240px;
    }

    .button-box {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      &__title {
        width: 5em;
        margin: 0 auto;

        .desc {
          color: #333;
        }
      }
    }

    .doctor-name {
      font-size: 22px;
      color: #333333;
    }

    .drug-list {
      &__header {
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
        padding-top: 10px;
      }

      &__content-item {
        display: flex;
        padding: 5px 0;
        border-bottom: 1px dashed #e5e5e5;

        .price {
          color: #ffc149;
        }

        .count {
          color: #0893ff;
        }

        .arrow-right-area {
          width: 21px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
    }
  }

  .harvest-address {
    padding-left: 20px;
    position: relative;

    &__header {
      border-bottom: 1px dashed #e5e5e5;
      padding-bottom: 10px;
    }

    .confirm-btn {
      position: absolute;
      left: 50%;
      margin-left: -91px;
      bottom: 90px;
      width: 182px;
      padding: 11px 0;
      font-size: 16px;
      color: #3692f9;
      text-align: center;
      line-height: 14px;
      background: #fafafa;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      cursor: pointer;
    }

    .status {
      color: #3692f9;
    }
  }
}

.detail_title {
  img {
    width: 20px;
    height: 20px;
  }
}

.btd {
  border-top: 1px #E5E5E5 dashed;
}
</style>
